/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/chatMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Chat. */
export class Chat {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Chat.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Generates an answer for the question
   * @summary Generates an answer for the question
   * @param [options] The optional parameters
   * @returns Promise<Models.ChatGetChatCompletionResponse>
   */
  getChatCompletion(options?: Models.ChatGetChatCompletionOptionalParams): Promise<Models.ChatGetChatCompletionResponse>;
  /**
   * @param callback The callback
   */
  getChatCompletion(callback: coreHttp.ServiceCallback<Models.DefenderChatResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getChatCompletion(options: Models.ChatGetChatCompletionOptionalParams, callback: coreHttp.ServiceCallback<Models.DefenderChatResponse>): void;
  getChatCompletion(options?: Models.ChatGetChatCompletionOptionalParams | coreHttp.ServiceCallback<Models.DefenderChatResponse>, callback?: coreHttp.ServiceCallback<Models.DefenderChatResponse>): Promise<Models.ChatGetChatCompletionResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getChatCompletionOperationSpec,
      callback) as Promise<Models.ChatGetChatCompletionResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getChatCompletionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/chat",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.DefenderChatRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.DefenderChatResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
